const initialStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#344F7A',
    padding: '8px 12px',
    backgroundColor: 'transparent'
  }),
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    border: '1px solid #2196F3',
    borderRadius: '10px',
    background: 'transparent',
    paddingLeft: '8px',
    minWidth: '180px'
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#2196F3',
    };
  }, dropdownIndicator: (base: any) => ({
    ...base,
    color: "#2196F3" // Custom colour
  })
  ,
  Input: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#2196F3',
  }),
  indicatorSeparator: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    backgroundColor: '#2196F3',
  }),
  indicatorContainer: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#2196F3',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #EBEBEB',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: "max-content",
    minWidth: "100%",
    zIndex:100,
  }),
}

const communicatorReplyStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#344F7A',
    padding: '8px 12px',
    backgroundColor: 'transparent'
  }),
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    border: '1px solid #c5ced6',
    borderRadius: '10px',
    background: 'transparent',
    paddingLeft: '8px',
    minWidth: '150px',
    maxWidth: '150px'
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#2196F3',
      fontSize: '12px'
    };
  }, dropdownIndicator: (base: any) => ({
    ...base,
    color: "hsl(0, 0%, 20%)" // Custom colour
  })
  ,
  Input: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#2196F3',
  }),
  indicatorSeparator: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    width:0,
    backgroundColor: '#2196F3',
  }),
  indicatorContainer: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    padding:'2px',
    color: '#2196F3',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #EBEBEB',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: "max-content",
    minWidth: "100%"
  }),
}

const communicatorNoteStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#ce7129',
    padding: '8px 12px',
    backgroundColor: 'transparent'
  }),
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    border: '1px solid #fdd88e',
    borderRadius: '10px',
    background: 'transparent',
    paddingLeft: '8px',
    minWidth: '150px',
    maxWidth: '150px'
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#ce7129',
      fontSize: '12px'
    };
  }, dropdownIndicator: (base: any) => ({
    ...base,
    color: "hsl(0, 0%, 20%)" // Custom colour
  })
  ,
  Input: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#ce7129',
  }),
  indicatorSeparator: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    width:0,
    backgroundColor: '#ce7129',
  }),
  indicatorContainer: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    padding:'2px',
    color: '#ce7129',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #fdd88e',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: "max-content",
    minWidth: "100%"
  }),
}
const communicatorReplyStylesEmbed = {
  container: (provided: any, state: any) => ({
    ...provided,
    flex: 1,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#344F7A',
    padding: '8px 12px',
    backgroundColor: 'transparent',
  }),
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    border: '1px solid #c5ced6',
    borderRadius: '10px',
    background: 'transparent',
    paddingLeft: '0',
    minWidth: '60px',
    maxWidth: '150px',
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#2196F3',
      fontSize: '12px',
    };
  },
  dropdownIndicator: (base: any) => ({
    ...base,
    color: 'hsl(0, 0%, 20%)', // Custom colour
  }),
  Input: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#2196F3',
  }),
  indicatorSeparator: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    width: 0,
    backgroundColor: '#2196F3',
  }),
  indicatorContainer: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    padding: '2px',
    color: '#2196F3',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #EBEBEB',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: 'max-content',
    minWidth: '100%',
    zIndex: 1000,
  }),
};

const communicatorNoteStylesEmbed = {
  container: (provided: any, state: any) => ({
    ...provided,
    flex: 1,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#ce7129',
    padding: '8px 12px',
    backgroundColor: 'transparent',
  }),
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    border: '1px solid #fdd88e',
    borderRadius: '10px',
    background: 'transparent',
    paddingLeft: '0',
    minWidth: '60px',
    maxWidth: '150px',
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#ce7129',
      fontSize: '12px',
    };
  },
  dropdownIndicator: (base: any) => ({
    ...base,
    color: 'hsl(0, 0%, 20%)', // Custom colour
  }),
  Input: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#ce7129',
  }),
  indicatorSeparator: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    width: 0,
    backgroundColor: '#ce7129',
  }),
  indicatorContainer: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    padding: '2px',
    color: '#ce7129',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #fdd88e',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: 'max-content',
    minWidth: '100%',
  }),
};

const programsStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#344F7A',
    padding: '8px 12px',
    backgroundColor: 'transparent',
  }),
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    border: '0px solid #c5ced6',
    borderRadius: '10px',
    background: 'transparent',
    paddingLeft: '8px',
    minWidth: '150px',
    boxShadow: 'none',
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#344F7A',
      // color: '#2196F3',
      // fontSize: '14px'
    };
  },
  dropdownIndicator: (base: any) => ({
    ...base,
    color: 'hsl(0, 0%, 20%)', // Custom colour
  }),
  Input: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#2196F3',
  }),
  indicatorSeparator: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    width: 0,
    backgroundColor: '#2196F3',
  }),
  indicatorContainer: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    padding: '2px',
    color: '#2196F3',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #EBEBEB',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: 'max-content',
    minWidth: '100%',
  }),
};
const mailboxesStyles = {
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '0px dotted pink',
    color: '#344F7A',
    padding: '8px 12px',
    backgroundColor: 'transparent',
    userSelect: 'none'
  }),
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    border: '1px solid #c5ced6',
    borderRadius: '10px',
    background: 'white',
    paddingLeft: '8px',
    minWidth: '150px',
    maxWidth: '250px',
    boxShadow: 'none',
  }),
  singleValue: (provided: any, state: any) => {
    return {
      ...provided,
      color: '#344F7A',
      // color: '#2196F3',
      // fontSize: '14px'
    };
  },
  dropdownIndicator: (base: any) => ({
    ...base,
    color: 'hsl(0, 0%, 20%)', // Custom colour
  }),
  Input: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    color: '#2196F3',
  }),
  indicatorSeparator: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    width: 0,
    backgroundColor: '#2196F3',
  }),
  indicatorContainer: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    // width: 200,
    ...provided,
    padding: '2px',
    color: '#2196F3',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: '10px',
    border: '1px solid #EBEBEB',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    width: 'max-content',
    minWidth: '100%',
    zIndex: 1000,
  }),
};

export const ReactSelectStyles = {
  initialStyles,
  communicatorReplyStyles,
  communicatorNoteStyles,
  communicatorReplyStylesEmbed,
  communicatorNoteStylesEmbed,
  programsStyles,
  mailboxesStyles,
}